import {Color} from "three";
import * as THREE from "three";

export const MATERIAL_PROPS_DB = [


    {
        materialName: "FloorMat",

        roughness: 0.65,
        // toneMapped:true,
    },

    {
        materialName: "GlassMat",
        glass: true,
        glassMatFunc: (envMap) => {
            return new THREE.MeshPhysicalMaterial({
                name: `GlassMat-MPM`,
                color: new THREE.Color(255, 255, 255),
                metalness: 0,
                roughness: 0,
                // alphaMap: texture,
                alphaTest: 0.5,
                envMap: envMap, //this.backgroundMap,
                envMapIntensity: .2,
                depthWrite: false,
                transmission: .8, // use material.transmission for glass materials
                opacity: 1, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true
            });
        },
    },

    {
        materialName: "VideoButtonBaseMat",

        envMapIntensity: 4.179193713700034,

    },


    {
        materialName: "UVT1",
        toneMapped: 'N',
    },
    {
        materialName: "UVT2",
        toneMapped: 'N',
    },
    {
        materialName: "UVT3",
        toneMapped: 'N',
    },
    {
        materialName: "UVT4",
        toneMapped: 'N',
    },
    {
        materialName: "UVT5",
        toneMapped: 'N',
    },
    {
        materialName: "UVT6",
        toneMapped: 'N',
    },
    {
        materialName: "UVT7",
        toneMapped: 'N',
    },
    {
        materialName: "UVT8",
        toneMapped: 'N',
    },
    {
        materialName: "UVT9",
        toneMapped: 'N',
    },
    {
        materialName: "UVT10",
        toneMapped: 'N',
    },
    {
        materialName: "UVT11",
        toneMapped: 'N',
    },
    {
        materialName: "UVT12",
        toneMapped: 'N',
    },
    {
        materialName: "UVT13",
        toneMapped: 'N',
    },
    {
        materialName: "UVT14",
        toneMapped: 'N',
    },
    {
        materialName: "UVT15",
        toneMapped: 'N',
    },


    {
        materialName: "LedgeEmmisiveMat",
        toneMapped: 'N',
    },

    {
        materialName: "WallMat",
        // aOIntensity: 0.872736590365562,
        aOIntensity: 0.8,
        envMapIntensity: 5,
    },


    {
        materialName: "HDRIMaterial",
        toneMapped: 'N',
    },

    {
        materialName: "LedgeMat",
        envMapIntensity: 5.0,
        aOIntensity:0.2760865660626288,
    },






]



